import { TranslateService } from '@ngx-translate/core';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { parseEnumValue } from '@nimmsta/ng-commons-lib/utils/enum';
import { MaintenanceStatus } from '../../models/scanner';

@Pipe({ name: 'toScannerDeviceMaintenanceStatusBadge' })
export class ScannerDeviceMaintenanceStatusBadgePipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(maintenanceStatus?: MaintenanceStatus | null): string {
    const normalizedStatus = parseEnumValue(
      MaintenanceStatus,
      maintenanceStatus,
      MaintenanceStatus.MISSING_DATA,
    );
    if (!normalizedStatus) {
      return '-';
    }
    const statusKey = this.statusKeyFromMaintenanceStatus(normalizedStatus);
    const text = this.translate.instant(`scanner.maintenance.statusValues.${statusKey}`);
    const badgeClass = normalizedStatus === MaintenanceStatus.OK ? 'active' : 'inactive';
    return (
      `<div class="badge rounded-pill text-bg-light"><div class="dot ${badgeClass}"></div>${text}</div>`
    );
  }
  private statusKeyFromMaintenanceStatus(status: MaintenanceStatus): string {
    switch (status) {
      case MaintenanceStatus.OK:
        return 'ok';
      case MaintenanceStatus.MISSING_DATA:
        return 'missing_data';
      case MaintenanceStatus.BATTERY_WARNING:
        return 'battery_warning';
      case MaintenanceStatus.SCAN_ENGINE_WARNING:
        return 'scan_engine_warning';
      case MaintenanceStatus.SOFTWARE_WARNING:
        return 'software_warning';
      case MaintenanceStatus.CUSTOM_FIRMWARE:
        return 'custom_firmware';
      case MaintenanceStatus.MULTIPLE_WARNINGS:
        return 'multiple_warnings';
    }
    const exhaustiveCheck: never = status;
    return exhaustiveCheck;
  }
}
